module.exports = __webpack_public_path__ + "img/dg.d0d43c89.jpg";